import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import StorySection from "./components/StorySection";
import CharactersSection from "./components/CharactersSection";
import ArcsSection from "./components/ArcsSection";
import FlamesSection from "./components/FlamesSection";
import WatchGuideSection from "./components/WatchGuideSection";
import WatchOrderSection from "./components/WatchOrderSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const reveals = Array.from(document.querySelectorAll<HTMLElement>(".reveal"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    reveals.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <IntroSection />
        <StorySection />
        <CharactersSection />
        <ArcsSection />
        <FlamesSection />
        <WatchGuideSection />
        <WatchOrderSection />
        <FaqSection />
      </main>
      <SiteFooter />

      <a
        href="#top"
        aria-label="回到页面顶部"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-all ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </a>
    </div>
  );
}